exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove_table_shadow .h-100 .datatable .table-responsive[data-v-29662803]{box-shadow:none!important}", ""]);

// exports
